import { FC } from 'react'
import { useField } from 'react-final-form'

import TextArea from '../molecules/TextArea'

type Props = {
  isConfirm: boolean
  label?: string
  required?: boolean
  placeholder?: string
}

const NAME = 'selfPr'

const SelfPrField: FC<Props> = ({
  isConfirm,
  label = '自己PR',
  required = false,
  placeholder = '職務経歴や学歴、ご自身の強み、習得している資格やスキル等、アピールポイントを記入してください。\n今後関わっていきたい仕事内容やジャンルも是非記入してみてください。',
}) => {
  const {
    input: { value },
  } = useField(NAME)

  if (isConfirm && !value) return null

  return (
    <TextArea
      label={label}
      name={NAME}
      isConfirm={isConfirm}
      required={required}
      placeholder={placeholder}
    />
  )
}

SelfPrField.displayName = 'selfPr'

export default SelfPrField
